'use client';

import React from 'react';
import dynamic from 'next/dynamic';

import { ArrowLeftIcon } from '../Icons';
import { ToolId, toolIdToSlug } from '../utils/slugs';
import { getToolSeoData } from '../utils/seo'; 
import { PillarContent } from './PillarContent';
import { UnitToggle } from '../UnitToggle';

// Dynamic import for InternalLinkRecommendations - loaded after main content
const InternalLinkRecommendations = dynamic(() => import('../InternalLinkRecommendations').then(mod => ({ default: mod.InternalLinkRecommendations })), {
    ssr: false
});

interface ToolContainerProps {
    title: string;
    description: string;
    children: React.ReactNode;
    setActiveTool?: (toolId: ToolId) => void;
    breadcrumbs: React.ReactNode;
    toolId?: ToolId; // New optional prop
}

export const ToolContainer: React.FC<ToolContainerProps> = ({ title, description, children, breadcrumbs, toolId }) => {

    return (
        <div className="p-2 sm:p-6 md:p-10 fade-in">
            <div className="flex justify-between items-center mb-6 bg-stone-50/50 p-3 rounded-xl border border-stone-100/50">
                {breadcrumbs}
            </div>
            {title && (
                <header className="mb-8 max-w-4xl flex flex-col md:flex-row md:items-end justify-between gap-6">
                    <div>
                        <h1 className="font-serif text-4xl md:text-5xl font-bold text-brand-text-title relative pb-2">
                            {title}
                        </h1>
                        <p className="mt-4 text-lg text-brand-text-body/80 max-w-2xl">{description}</p>
                    </div>

                    {/* Unit Toggle */}
                    <UnitToggle />
                </header>
            )}


            <div className="bg-white p-4 sm:p-8 rounded-2xl border border-brand-border shadow-sm overflow-hidden">
                {children}
            </div>

            {toolId && <PillarContent seoData={getToolSeoData(toolId)} />}

            <InternalLinkRecommendations activeTool={toolId} />


        </div>
    );
};
